import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class LinkedPropertyModel extends Model {
  @attr('boolean', { defaultValue: true }) linkedUnavailabilities!: boolean;

  @belongsTo('property', {
    inverse: null,
    async: false,
  })
  property!: ModelRegistry['property'];

  @hasMany('property', {
    inverse: null,
    async: false,
  })
  properties!: ModelRegistry['property'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'linked-property': LinkedPropertyModel;
  }
}
